import { createHtmlElement, ElementAttribute, ElementStyle } from './create-html-element';

export type CursorType = 'default' | 'pointer';

export const createPopupOverlayElement = (cursor: CursorType = 'default') => {
  const styles: ElementStyle[] = [
    { property: 'font-family', value: 'Helvetica Neue, Helvetica, Arial' },
    { property: 'width', value: '100%' },
    { property: 'height', value: '100%' },
    { property: 'top', value: '0' },
    { property: 'left', value: '0' },
    { property: 'position', value: 'fixed' },
    { property: 'z-index', value: '232323' },
    { property: 'color', value: '#fff' },
    { property: 'background', value: 'rgba(0, 0, 0, 0.8)' },
    { property: 'box-sizing', value: 'border-box' },
    { property: 'border', value: '1px solid #eee' },
    { property: 'cursor', value: cursor },
    { property: 'display', value: 'flex' },
    { property: 'justify-content', value: 'center' },
    { property: 'align-items', value: 'center' },
  ];
  const attributes: ElementAttribute[] = [
    {
      name: 'id',
      value: 'mgp-sdk-popup-overlay',
    },
  ];
  return createHtmlElement('div', styles, attributes);
};
